<template>
  <!-- eslint-disable max-len -->
  <div class="Table">
    <div class="row">
      <div class="col category">
        <span class="bold">What Personal Information Do We Collect About You?</span>
        <img alt="Document icon" src="../assets/document.png">
      </div>
      <div class="col information">
        <ul>
          <li>
            <span class="bold">Contact Information</span>
            (such as name, phone number, fax number, postal address or email address)
          </li>
          <li>
            <span class="bold">Payment Information</span>
            (such as name, billing address, and credit card or debit card information, e.g., when
            making a purchase)
          </li>
          <li>
            <span class="bold">Demographic Information</span>
            (such as age, gender, race, income level)
          </li>
          <li>
            <span class="bold">Online Identifiers</span>
            (such as IP address, internal and third party identifiers, advertising identifiers and
            device information like unique device ID)
          </li>
          <li>
            <span class="bold">Location Information</span>
            (imprecise location data derived from an IP address)
          </li>
          <li>
            <span class="bold">Internet Activity Information</span>
            (such as browsing history, information on how you interact with our Sites (e.g., which
            articles or ads you click on, whether you click on links in our emails), and your
            interactions with social media platform features)
          </li>
          <li>
            <span class="bold">
              Inferences about Your Interests, Preferences and other Behavioral Data
            </span>
            (based on your use of or opinions about various products, programs and services).
          </li>
          <li>
            <span class="bold">Voice and Audio Information</span>
            (we may record telephone calls between you and Synapse, Inc.)
          </li>
        </ul>
        <a class="more" href="#personal">MORE</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span class="bold">Where/How Do We Collect Information About You?</span>
        <img alt="Devices icon" src="../assets/devices.png">
      </div>
      <div class="col information">
        <ul>
          <li>
            <span class="bold">From You:</span>
            <ul><li>When you enter information on the Sites</li></ul>
          </li>

          <li>
            <span class="bold">From Your Device:</span>
            <ul>
              <li>
                <span class="bold">From Cookies & Other Technologies</span> (information stored
                on your browser, which tell us your browser, device information, IP address,
                and how you interact with the Sites).
              </li>
            </ul>
          </li>
          <li>
            <span class="bold">From Others:</span>
            <ul>
              <li>Advertisers</li>
              <li>Data Partners</li>
              <li>Service Providers</li>
            </ul>
          </li>
        </ul>
        <a class="more" href="#collect">MORE</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span class="bold">How Do We Use Your Information?</span>
        <img alt="Gear icon" src="../assets/gear.png">
      </div>
      <div class="col information">
        <span class="bold">We use your information:</span>
        <ul>
          <li>
            To <span class="bold">fulfill your requests for our publications,
            products or services</span>.
          </li>
          <li>To <span class="bold">provide customer support</span>.</li>
          <li>
            To <span class="bold">communicate with you</span> (such as to notify you when you
            have won one of our contests or sweepstakes, when we make changes to subscriber
            agreements, to fulfill a request by you for an online newsletter, or to contact you
            about your account).
          </li>
          <li>
            To <span class="bold">build customer profiles and enhance our ability to market to you</span> those products or services that may be of interest to you.
          </li>
          <li>
            To <span class="bold">restrict certain portions of our website to visitors from the United States</span>.
          </li>
          <li>
            To <span class="bold">protect you and us</span> from fraud and other security
            issues.
          </li>
        </ul>
        <a class="more" href="#use">MORE</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span class="bold">Who Do We Share Your Information With?</span>
        <img alt="Lock icon" src="../assets/shareInfo.png">
      </div>
      <div class="col information">
        <ul>
          <li>
            With <span class="bold">the brands</span> who we partner with to provide programs to you.
          </li>
          <li>
            With our <span class="bold">service providers</span> who help operate our Sites and provide our services to you.
          </li>
          <li>
            With <span class="bold">third party data partners</span> who help us identify you and who give us additional information about you that helps us deliver services and improve our programs and services.
          </li>
          <li>
            As <span class="bold">required by law</span>.
          </li>
          <li>
            With a <span class="bold">buyer of all or part of our business</span>.
          </li>
          <li>
            With other third parties, <span class="bold">when we have your consent</span>.
          </li>
        </ul>
        <a class="more" href="#share">MORE</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span class="bold">How Can You Control Our Use of Your Information?</span>
        <img alt="Lock icon" src="../assets/lock.png">
      </div>
      <div class="col information">
        You can tell us how we can use your information by clicking on the links below:
        <ul>
          <li>
            If you prefer not to receive promotions from Synapse Group Inc., or if you want to opt-out of any sharing of your personal offline information with our affiliates or third parties, please click
            <a
              :href="'http://privacy.synapsegroupinc.com/optout.html?id=' + id"
              target="_blank"
              rel="noopener noreferrer"
            >here</a>.
          </li>
          <li>
            To request deletion or access to your information click
            <a
              href="https://privacyportalde-cdn.onetrust.com/dsarwebform/2159c482-749a-49db-916b-475017a9efa5/855e3b71-3dd3-4546-977c-88c7430ade09.html"
              target="_blank"
              rel="noopener noreferrer"
            >here</a>.
          </li>
        </ul>
        <a class="more" href="#control">MORE</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span class="bold">Children's Privacy</span>
        <img alt="Child icon" src="../assets/child.png">
      </div>
      <div class="col information">
        We do not knowingly collect information from anyone under the age of 16.
        <a class="more" href="#children">MORE</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span class="bold">Rights for Our California Residents</span>
        <img alt="California icon" src="../assets/california.png">
      </div>
      <div class="col information">
        If you’re a resident of California, you have the right to:
        <ul>
          <li>
            <span class="bold">Know that we do not share your personal information with third parties for their direct marketing purposes if you have opted-out of such data sharing.</span>
            <ul>
              <li>If you would like to opt-out, please click
              <a href="https://privacyportalde-cdn.onetrust.com/dsarwebform/2159c482-749a-49db-916b-475017a9efa5/78860ee2-92a0-45b1-bd4e-1d28fb6a8c11.html" target="_blank" rel="noopener noreferrer">here</a>
              </li>
            </ul>
          </li>
        </ul>
        <a class="more" href="#section4">MORE</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span class="bold">How You Can Learn More</span>
        <img alt="Lightbulb icon" src="../assets/lightbulb.png">
      </div>
      <div class="col information">
        Click here to read our full <a href="#personal">Privacy Statement</a>
        <br />
        <br />
        Still can’t find what you’re looking for about our data privacy practices? Don’t worry, just
        reach out to us via email by <a href="mailto:Privacy@synapsemail.com">clicking here</a> and we will get back to you!
        <a class="more" href="#learn">MORE</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Table',
  props: {
    id: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Table {
  border: 1px solid darkgray;
}

.row {
  display: flex;
  flex-direction: column;

  @media (min-width: 576px) {
    flex-direction: row;
  }
}

.col.category {
  padding: 1em 0.5em;
  border-bottom: 1px dashed darkgray;
  text-align: center;

  img {
    display: block;
    margin: auto;
    width: 100px;
    height: auto;
  }

  @media (min-width: 576px) {
    width: 400px;
    border-bottom: 1px solid darkgray;
    border-right: 1px dashed darkgray;
  }
}

.col.information {
  padding: 1em 0.5em;
  border-bottom: 1px solid darkgray;

  ul {
    margin: 0;
  }

  a.more {
    width: 100%;
    display: block;
    text-align: right;
  }

  @media (min-width: 576px) {
    width: 400px;
    flex-grow: 1;
  }
}
</style>
